import { Link } from 'react-router-dom';

export function NotFound(): JSX.Element {
  return (
    <section className="container-fc py-20 text-center">
      <h1 className="font-display text-5xl text-fc-ink">404</h1>
      <p className="mt-4 text-fc-muted">No encontramos esa página.</p>
      <Link to="/" className="mt-6 inline-block underline hover:text-fc-ink">
        Volver al inicio
      </Link>
    </section>
  );
}
